import { useEffect, useState } from "react";
import ItemEditor from "./ItemEditor";

export const STATUS_STYLE = {
  approved: "bg-[#1E1E1E] text-[#F3F1EC]",
  in_review: "bg-[#DB9130] text-[#1E1E1E]",
  draft: "bg-[#FBE7D2] text-[#8a5a12]",
  rejected: "bg-[#B3261E] text-white",
};
const sel = "border-2 border-[#D3CFC0] bg-white px-2 py-1.5 text-sm focus:border-[#1E1E1E] outline-none";

export default function LibraryList({ api, opts, filter, setFilter }) {
  const [items, setItems] = useState(null);
  const [open, setOpen] = useState(null);

  const load = () => {
    const p = new URLSearchParams(Object.entries(filter).filter(([, v]) => v)).toString();
    api.get(`/admin/starter-kit/items?${p}`).then((r) => setItems(r.data.items));
  };
  useEffect(load, [filter.sport, filter.age, filter.type, filter.status, filter.q]);
  const set = (k) => (e) => setFilter((f) => ({ ...f, [k]: e.target.value }));

  return (
    <div className="space-y-4" data-testid="sk-library">
      <div className="flex flex-wrap gap-2">
        <select data-testid="sk-filter-sport" value={filter.sport} onChange={set("sport")} className={sel}>
          <option value="">All sports</option>{opts.sports.map((s) => <option key={s}>{s}</option>)}
        </select>
        <select data-testid="sk-filter-age" value={filter.age} onChange={set("age")} className={sel}>
          <option value="">All ages</option>{opts.ages.map((s) => <option key={s}>{s}</option>)}
        </select>
        <select data-testid="sk-filter-type" value={filter.type} onChange={set("type")} className={sel}>
          <option value="">All types</option>{opts.types.map((s) => <option key={s}>{s}</option>)}
        </select>
        <select data-testid="sk-filter-status" value={filter.status} onChange={set("status")} className={sel}>
          <option value="">All statuses</option>{opts.statuses.map((s) => <option key={s}>{s}</option>)}
        </select>
        <input data-testid="sk-filter-q" value={filter.q} onChange={set("q")} placeholder="Search title or id" className={`${sel} min-w-[200px]`} />
      </div>
      {!items ? <p className="text-[#6E6E6E]">Loading…</p> : (
        <>
          <p className="text-xs font-[IBM_Plex_Mono] text-[#6E6E6E]" data-testid="sk-items-count">{items.length} items</p>
          <div className="divide-y-2 divide-[#EDE8DC] border-2 border-[#D3CFC0]">
            {items.map((it) => (
              <div key={it.id}>
                <button data-testid={`sk-item-${it.id}`} onClick={() => setOpen(open === it.id ? null : it.id)}
                  className="w-full text-left px-3 py-2 flex flex-wrap items-center gap-3 hover:bg-[#F7F3EC] transition-colors">
                  <span className={`text-[10px] uppercase font-[IBM_Plex_Mono] px-2 py-0.5 ${STATUS_STYLE[it.review_status]}`}>{it.review_status.replace("_", " ")}</span>
                  <span className="font-head uppercase text-sm text-[#1E1E1E] flex-1 min-w-[180px]">{it.title}</span>
                  <span className="text-xs text-[#6E6E6E]">{it.type} · {it.age_groups.join(", ")}</span>
                  {it.founder_written && <span className="text-[10px] uppercase text-[#DB9130] font-[IBM_Plex_Mono]">Founder</span>}
                  {it.technique_review === "pending" && <span className="text-[10px] uppercase text-[#B3261E] font-[IBM_Plex_Mono]">Technique cue</span>}
                  {it.edited && <span className="text-[10px] uppercase text-[#6E6E6E] font-[IBM_Plex_Mono]">Edited v{it.version}</span>}
                </button>
                {open === it.id && <ItemEditor api={api} id={it.id} opts={opts} onChanged={load} />}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
